import Section from '@/components/Section'
import React from 'react'
import style from './styles/game_detail.module.scss'
import Title from '@/components/Title'
import NewLabel from '@/components/Labels/NewLabel'
import Container from '@/components/Container'
import PlayButton from '@/components/Button/PlayButton'
import ImageAndDownload from './components/ImageAndDownload'
import HtmlContent from '@/components/HtmlContent'
import { ISystemRequirements } from '@/interfaces/Game'

interface IProps {
  title: string
  description: string
  isNew: boolean
  screenshots: string[]
  playVideo: string
  setPlayVideo: any
  detailPicture?: string
  video?: string
  preview: string
  systems: ISystemRequirements[]
}

const Description = ({
  detailPicture,
  title,
  description,
  isNew,
  video,
  screenshots,
  playVideo,
  setPlayVideo,
  systems,
  preview
}: IProps): React.ReactElement => {
  const handlePlayVideo = (): void => {
    setPlayVideo('description')
  }
  // вынести стейт на уровень выше, значение - id видоса

  return (
    <Section>
      <Container>
        <div className={style.desc_top}>
          <ImageAndDownload detailPicture={detailPicture} systems={systems} />
          <div className={style.desc_right}>
            <div className={style.desc__title_wrap}>
              <Title type='h1'>{title}</Title>
              {isNew ? <NewLabel className={style.desc__new} /> : ''}
            </div>
            <ImageAndDownload detailPicture={detailPicture} mobileView systems={systems} />
            <div className={style.desc_grid}>
              {video !== undefined
                ? (
                  <div className={style.desc_video__wrap}>
                    {playVideo === 'description'
                      ? (
                        <video
                          width='400px'
                          height='300px'
                          controls
                          controlsList='nodownload'
                          autoPlay
                          className={style.desc_video}
                        >
                          <source src={video} type='video/mp4' />
                        </video>
                        )
                      : (
                        <>
                          <img
                            src={preview}
                            width='560px'
                            height='311px'
                            alt='Превью видео'
                            className={style.desc_video__preview}
                          />

                          <PlayButton
                            onClick={handlePlayVideo}
                            className={style.desc_video__button}
                          />
                        </>
                        )}
                  </div>
                  )
                : (
                    ''
                  )}
              {screenshots.map((el) => {
                return (
                  <img
                    key={el}
                    src={el}
                    width='270px'
                    height='150px'
                    alt='Скриншот игры'
                    className={style.desc__screenshot}
                  />
                )
              })}
            </div>
          </div>
        </div>
        <Title type='h2' theme='h3'>
          Описание
        </Title>
        <HtmlContent content={description} className={style.desc__text} />
      </Container>
    </Section>
  )
}

export default Description
